import script from "./Extra.vue?vue&type=script&lang=ts&setup=true"
export * from "./Extra.vue?vue&type=script&lang=ts&setup=true"

import "./Extra.vue?vue&type=style&index=0&id=4dd05062&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd05062"]])

export default __exports__